// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)
